import React from 'react';

const Portfolio = () => (
    <p>Portfolio</p>
);

export default Portfolio;